import {
  Menu,
  MenuItem,
  FormControlLabel,
  Divider,
  Grid2,
  IconButton,
  Tooltip,
  Checkbox,
  Collapse,
} from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { ExpandMore, FilterAltOff } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useLoading } from "../../../../components/Loading";
import { useSnackbar } from "../../../../context/popup";
import { fetchData } from "../../../../services";
import DropDownConfig from "../../../Utils/DropDownConfig";

const ExternalApiRegistryFilterDialog = ({
  anchorEl,
  open,
  onClose,
  filterData,
  setFilterData,
  onApply,
}) => {
  const sectionHeader = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "2px 6px",
    background: "#e9ecf5",
    borderRadius: "6px",
    cursor: "pointer",
    mb: 0.5,
  };

  const menuItemStyle = {
    borderRadius: "6px",
    my: 0.2,
    mx: 0.5,
    py: 0.3,
    "&:hover": { backgroundColor: "#dfe6ff" },
  };

  const labelStyle = {
    m: 0,
    "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
  };

  const { showSnackbar } = useSnackbar();

  const [openActive, setOpenActive] = useState(false);
  const [openCity, setOpenCity] = useState(false);
  const [openRtoRegion, setOpenRtoRegion] = useState(false);
  const [openRtoZone, setOpenRtoZone] = useState(false);
  const [generalProductOptions, setGeneralProductOptions] = useState([]);
  const [apiStatusOptions, setApiStatusOptions] = useState([]);
  const [registryOptions, setRegistryOptions] = useState([]);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const results = await Promise.allSettled([
          fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalProduct}`), // gProductId

          fetchData(
            `/api-engine/key-value-store?dropdown=true&isActive=true&code=${DropDownConfig?.apiStatus}`
          ), // apiStatus

          fetchData(`/reference/api-engine/insurer-registry?dropdown=true`), // registry
        ]);

        const [productResult, apiStatusResult, registryResult] = results;

        // General Product
        if (
          productResult.status === "fulfilled" &&
          productResult.value?.success
        ) {
          setGeneralProductOptions(
            productResult.value.data?.items?.map((item) => ({
              value: item.id,
              label: item.keyName,
            })) || []
          );
        }

        // API Status
        if (
          apiStatusResult.status === "fulfilled" &&
          apiStatusResult.value?.success
        ) {
          setApiStatusOptions(
            apiStatusResult.value.data?.items?.map((item) => ({
              value: item.id,
              label: item.keyName,
            })) || []
          );
        }
        // Registry (FIXED: correct response used)
        if (
          registryResult.status === "fulfilled" &&
          registryResult.value?.success
        ) {
          setRegistryOptions(
            registryResult.value.data?.insurer_registries?.map((item) => ({
              value: item.id,
              label: `iRegistry-${item.id}`,
            })) || []
          );
        }

        // Optional warning if any API failed
        if (results.some((r) => r.status === "rejected")) {
          showSnackbar("Some dropdowns failed to load", "warning");
        }
      } catch (error) {
        console.error("Unexpected dropdown error:", error);
        showSnackbar("Error fetching Dropdowns", "error");
      }
    };
    if(open){
      fetchDropdowns();
    }else{
      return;
    }
  }, [open]);

  const handleChange = ({ target: { name, value } }) => {
    setFilterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onClearFilters = () => {
    setFilterData({
      isActive: "",
      iRegistryId: "",
      gProductId: "",
      apiStatusId: "",
    });
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}
      PaperProps={{
        elevation: 3,
        sx: {
          width: 240,
          padding: 1.5,
        },
      }}
    >
      <MaterialBox
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Title */}
        <MaterialTypography variant="body2" fontWeight="bold">
          API Registry Filter
        </MaterialTypography>

        {/* Clear Button */}
        <Tooltip title="Clear Filter" disableInteractive>
          <IconButton
            size="small"
            onClick={onClearFilters}
            sx={{ color: "#ce0707ff" }}
          >
            <FilterAltOff />
          </IconButton>
        </Tooltip>
      </MaterialBox>

      {/* Content */}
      <MaterialBox
        ml={1}
        mt={1}
        sx={{
          maxHeight: 300,
          overflowY: "auto",
        }}
      >
        <Grid2 container spacing={1}>
          <Grid2 size={{ xs: 12 }}>
            <MaterialBox>
              <MaterialBox
                sx={sectionHeader}
                onClick={() => setOpenActive(!openActive)}
              >
                <MaterialTypography variant="body3" fontWeight="bold">
                  Active Status
                </MaterialTypography>

                <IconButton size="small">
                  <ExpandMore
                    sx={{
                      transform: openActive ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "0.2s",
                    }}
                  />
                </IconButton>
              </MaterialBox>

              <Collapse in={openActive}>
                <MenuItem
                  disableRipple
                  sx={menuItemStyle}
                  onClick={() =>
                    handleChange({
                      target: { name: "isActive", value: true },
                    })
                  }
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={filterData.isActive === true}
                      />
                    }
                    label="Active"
                    sx={labelStyle}
                  />
                </MenuItem>

                <MenuItem
                  disableRipple
                  sx={menuItemStyle}
                  onClick={() =>
                    handleChange({
                      target: { name: "isActive", value: false },
                    })
                  }
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={filterData.isActive === false}
                      />
                    }
                    label="Inactive"
                    sx={labelStyle}
                  />
                </MenuItem>
              </Collapse>
            </MaterialBox>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <MaterialBox>
              <MaterialBox
                sx={sectionHeader}
                onClick={() => setOpenCity(!openCity)}
              >
                <MaterialTypography variant="body3" fontWeight="bold">
                  General Product
                </MaterialTypography>

                <IconButton size="small">
                  <ExpandMore
                    sx={{
                      transform: openCity ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "0.2s",
                    }}
                  />
                </IconButton>
              </MaterialBox>

              <Collapse in={openCity}>
                {generalProductOptions?.map((item) => (
                  <MenuItem
                    key={item.value}
                    disableRipple
                    sx={menuItemStyle}
                    onClick={() =>
                      handleChange({
                        target: { name: "gProductId", value: item.value },
                      })
                    }
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          checked={filterData.gProductId === item.value}
                        />
                      }
                      label={item.label}
                      sx={labelStyle}
                    />
                  </MenuItem>
                ))}
              </Collapse>
            </MaterialBox>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <MaterialBox>
              <MaterialBox
                sx={sectionHeader}
                onClick={() => setOpenRtoRegion(!openRtoRegion)}
              >
                <MaterialTypography variant="body3" fontWeight="bold">
                  API Status
                </MaterialTypography>

                <IconButton size="small">
                  <ExpandMore
                    sx={{
                      transform: openRtoRegion
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      transition: "0.2s",
                    }}
                  />
                </IconButton>
              </MaterialBox>

              <Collapse in={openRtoRegion}>
                {apiStatusOptions?.map((item) => (
                  <MenuItem
                    key={item.value}
                    disableRipple
                    sx={menuItemStyle}
                    onClick={() =>
                      handleChange({
                        target: { name: "apiStatusId", value: item.value },
                      })
                    }
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          checked={filterData.apiStatusId === item.value}
                        />
                      }
                      label={item.label}
                      sx={labelStyle}
                    />
                  </MenuItem>
                ))}
              </Collapse>
            </MaterialBox>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <MaterialBox>
              <MaterialBox
                sx={sectionHeader}
                onClick={() => setOpenRtoZone(!openRtoZone)}
              >
                <MaterialTypography variant="body3" fontWeight="bold">
                  Insurer Registry
                </MaterialTypography>

                <IconButton size="small">
                  <ExpandMore
                    sx={{
                      transform: openRtoZone
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      transition: "0.2s",
                    }}
                  />
                </IconButton>
              </MaterialBox>

              <Collapse in={openRtoZone}>
                {registryOptions?.map((item) => (
                  <MenuItem
                    key={item.value}
                    disableRipple
                    sx={menuItemStyle}
                    onClick={() =>
                      handleChange({
                        target: {
                          name: "iRegistryId",
                          value: item.value,
                        },
                      })
                    }
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          checked={filterData.iRegistryId === item.value}
                        />
                      }
                      label={item.label}
                      sx={labelStyle}
                    />
                  </MenuItem>
                ))}
              </Collapse>
            </MaterialBox>
          </Grid2>
        </Grid2>
      </MaterialBox>

      <Divider />

      {/* Apply button */}
      <MenuItem
        onClick={() => onApply()}
        disableRipple
        sx={{
          padding: "6px 16px",
          width: "fit-content",
          minWidth: "0px",
          mx: "auto",
          borderRadius: "6px",
          backgroundColor: "#bcc7e9",
          color: "white",
          display: "flex",
          justifyContent: "center",
          transition: "0.2s ease",

          "&:hover": {
            backgroundColor: "#93a6e8",
          },
        }}
      >
        <MaterialTypography variant="button" fontWeight="bold">
          APPLY FILTER
        </MaterialTypography>
      </MenuItem>
    </Menu>
  );
};

export default ExternalApiRegistryFilterDialog;
